module.exports = __webpack_public_path__ + "img/capa2.ca55d99f.webp";